import React, { Component } from 'react';

class FramedSize extends Component {
  	render() {
  		const {frameSizeH, frameSizeW} = this.props;
	    return (
	       <tr> 
				<th>Framed Size</th> 
				<td>
					{frameSizeW}cm x {frameSizeH}cm
				</td>
				<td></td> 
            </tr>
	    );
  	}
}

export default FramedSize;